import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarRegisterList } from "../../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";
import { TUnchosenProfessionalPriorityForm } from "../unchosenProfessionalPrioritySchema";
import { IUnchosenProfessionalCalendarsProps } from "./models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalCalendars = memo(
  ({ index }: IUnchosenProfessionalCalendarsProps) => {
    const { t } = useTranslation();

    const { sendRequest } = useFetch(calendarRegisterList);

    const [optionsCalendars, setOptionsCalendars] = useState<ISelectType[]>([]);

    const { setValue, clearErrors, trigger } =
      useFormContext<TUnchosenProfessionalPriorityForm>();

    const handleChangeValues = useCallback(() => {
      setValue(`thenPriorities.${index}.physicians`, null);
      clearErrors(`thenPriorities.${index}.physicians`);
      trigger([
        `thenPriorities.${index}.calendars`,
        `thenPriorities.${index}.physicians`,
      ]);
    }, [index, setValue, clearErrors, trigger]);

    const fetchCalendars = useCallback(async () => {
      const { data, success } = await sendRequest({
        tasyScheduleTypeCode: 3,
      });
      if (data && success) {
        setOptionsCalendars(
          data.map((calendar) => ({
            id: calendar.identifier.toString(),
            name: `${calendar.descriptionSite?.trim() || calendar.calendarName} - ${calendar.identifier}`,
          })),
        );
      }
    }, [sendRequest]);

    useEffect(() => {
      fetchCalendars();
    }, [fetchCalendars]);

    return (
      <AutoComplete
        getOptionLabel={({ name }) => name}
        name={`thenPriorities.${index}.calendars`}
        size="small"
        options={optionsCalendars}
        label={t(translationPath + "calendars")}
        onAfterValueChange={handleChangeValues}
        fullWidth
      />
    );
  },
);
